import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  card: {
    position: 'relative',
    textAlign: 'center',
    marginBottom: 20,
    minHeight: 200,
    border: '1px solid #9e9e9e',
    borderRadius: 8,
    boxShadow: 'unset'
  },
  descriptionBox: {
    position: 'absolute',
    bottom: 0,
    transform: 'translateY(calc(100% - 50px))',
    width: '100%',
    height: 'auto',
    backgroundColor: theme.palette.primary.main,
    transition: 'all 0.5s',
    padding: 8,
    paddingTop: 60,
    boxSizing: 'border-box',
    color: theme.palette.common.white,
    fontSize: '0.9em'
  },
  title: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    top: 0,
    color: theme.palette.common.white,
    textAlign: 'center',
    width: 'inherit',
  },
  icon: {
    fontSize: 50,
    textAlign: 'center',
    marginTop: '70px',
    width: '100% !important',
    height: '100% !important'
  },
}));

export default useStyles;
